import 'regenerator-runtime/runtime';
import { call, put, select, take, takeEvery } from 'redux-saga/effects';
import {
  GlobalAction,
  GlobalActions,
  GlobalPut,
  VorbelegungPayload,
} from '@ps20-frontend/shop-integration-redux';
import { App, UnfallVorbelegungdaten } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { Selbstbeteiligung } from '@ps20/bff-models';
import { IAppState } from '../appState';

export function* watchVorbelegungRequested() {
  yield takeEvery(GlobalActions.VORBELEGUNG_REQUESTED, safeSaga(vorbelegungSaga, App.UNF));
}

const globalActions = new GlobalActions();

export function* vorbelegungSaga(action: GlobalAction<VorbelegungPayload>) {
  const state: IAppState = yield select();
  if (action.payload.appId !== App.UNF || action.payload.angebotsId !== state.angebotsId) {
    return;
  }
  let beibehalten = false;
  const globalPut = GlobalPut.getInstance();
  if (!state.produkt?.produktlinien || state.produkt?.produktlinien.length === 0) {
    yield take(GlobalActions.PRODUKT_RECEIVED);
  }

  const vorhandeneVorbelegungdaten = action.payload.vorhandeneVorbelegungdaten;
  if (vorhandeneVorbelegungdaten?.internerVertragsbezugs) {
    yield put(
      globalActions.internerVertragsbezugReceived(
        vorhandeneVorbelegungdaten.internerVertragsbezugs,
        App.UNF,
        state.angebotsId,
      ),
    );
  }

  if (!state.vertragsoptionen?.beibehalten) {
    yield call(
      [globalPut, globalPut.put],
      globalActions.navigationRequested({ appId: App.UNF, subroute: '/eingabe' }),
    );
  } else {
    beibehalten = true;
    const unfallVorbelegungdaten: UnfallVorbelegungdaten = {
      ...(vorhandeneVorbelegungdaten as UnfallVorbelegungdaten),
      angebotsId: action.payload.angebotsId,
      selbstbeteiligung: Selbstbeteiligung.SELBSTBETEILIGUNG_0000,
    };
    yield call(
      [globalPut, globalPut.put],
      globalActions.vorbelegungForBeibehaltungRequested(unfallVorbelegungdaten),
    );
  }
  yield call(
    [globalPut, globalPut.put],
    globalActions.vorbelegungFinished({
      appId: App.UNF,
      vorhandeneVorbelegungdaten: action.payload
        .vorhandeneVorbelegungdaten as UnfallVorbelegungdaten,
      angebotsId: action.payload.angebotsId,
      beibehalten,
    }),
  );
}
